import { createFileRoute } from '@tanstack/react-router';

import { LoadingPage } from '@nesso/ui/blocks/loading-page';

import { OnlinePaymentsPage, onlinePaymentsBeforeLoad } from '@/pages/settings/online-payments';

export const Route = createFileRoute('/settings/online-payments')({
    beforeLoad: onlinePaymentsBeforeLoad,
    component: OnlinePaymentsPage,
    pendingComponent: LoadingPage,
});
